export * from './labs.js';
export * from './local-storage.js';
export * from './modals.js';
export * from './preferences.js';
export * from './tour.jsx';
export * from './sort.js';

export const ITEM_COUNT_LIMIT = 100;
export const DEFAULT_ZOOM = 2;
export const DRAG_TYPE = 'Text';
export const MAX_ZOOM = 20; // map stops here
export const MAX_TITLE_LENGTH = 255;

/** Downsampling Limits */
export const DOWNSAMPLE_ZOOM = 11;
export const DOWNSAMPLE_THRESHOLD = 0.25;

export const MAX_TILESET_ITEMS = 30;
export const MAX_VISIBLE_RESULTS = 10;

export const MAX_GEOMETRY_AREA = 50000; // Maximum area in square km

export const UI_MODES = {
  BROWSE: 'browse',
  COMPARE: 'compare',
};

export const GEO_PROJECTION = 'EPSG:4326';
export const WEB_PROJECTION = 'EPSG:3857';

export const PROJECTION_LABELS = {
  3857: 'Web Mercator (EPSG: 3857)',
  4326: 'World Geodetic System (EPSG: 4326)',
};

export const TILE_MODE = {
  RESULTS: 'mode-results',
  BASEMAPS: 'mode-basemaps',
};

export const DRAWERS = {
  SEARCH: 'search-drawer',
  ORDERS: 'orders-drawer',
  SETTINGS: 'settings-drawer',
  SAVED_SEARCHES: 'saved-searches-drawer',
  BASEMAPS: 'basemaps-drawer',
  COLLECTIONS: 'collections-drawer',
  UPLOADS: 'uploads-drawer',
};

export const CONTACT_SALES_URL =
  'https://learn.planet.com/contact-us-explorer.html';

export const MAP_TOOLS = {
  DRAW_LOCKED_CIRCLE: 'draw-locked-circle',
  DRAW_LOCKED_RECT: 'draw-locked-rect',

  DRAW_POLYGON: 'draw-polygon',
  DRAW_CIRCLE: 'draw-circle',
  DRAW_RECT: 'draw-rect',
  DRAW_LINE: 'draw-line',

  EDIT: 'draw-edit',

  BOX_ZOOM: 'box-zoom',

  NONE: '',
};

export const MAP_DRAW_LAYERS = {
  GEOMETRY: 'geometry',
  MEASURE: 'measure',
  NONE: 'none',
};
